module.exports = __webpack_public_path__ + "img/stamp.876a3f35.svg";